// Ubicación en el repo: src/components/PrescriptionDetailModal.jsx
// "Ver receta" — mismo contenido que openPrescriptionDetail() del
// prototipo (línea ~2461): tablas Lejos/AV, ADD/ADD intermedia/DP/Uso,
// tabla Cerca, diagnóstico, aviso de reevaluar, observaciones.
import { formatPatientName, formatProfessionalName, formatDate } from '../lib/format';

function cell(v) {
  return v !== null && v !== undefined && v !== '' ? v : '—';
}

function LensSummaryTable({ block }) {
  const od = block?.od || {};
  const oi = block?.oi || {};
  return (
    <table className="detail-table">
      <thead>
        <tr>
          <th></th>
          <th className="freq-table__od">Esfera</th>
          <th className="freq-table__od">Cilindro</th>
          <th className="freq-table__od">Eje</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="freq-table__od" style={{ fontWeight: 700 }}>
            OD
          </td>
          <td>{cell(od.esfera)}</td>
          <td>{cell(od.cilindro)}</td>
          <td>{cell(od.eje)}</td>
        </tr>
        <tr>
          <td className="freq-table__oi" style={{ fontWeight: 700 }}>
            OI
          </td>
          <td>{cell(oi.esfera)}</td>
          <td>{cell(oi.cilindro)}</td>
          <td>{cell(oi.eje)}</td>
        </tr>
      </tbody>
    </table>
  );
}

function AvSummaryTable({ av }) {
  const od = av?.od || {};
  const oi = av?.oi || {};
  return (
    <table className="detail-table">
      <thead>
        <tr>
          <th></th>
          <th className="freq-table__od">AVsc</th>
          <th className="freq-table__od">AVcc</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="freq-table__od" style={{ fontWeight: 700 }}>
            OD
          </td>
          <td>{cell(od.sc)}</td>
          <td>{cell(od.cc)}</td>
        </tr>
        <tr>
          <td className="freq-table__oi" style={{ fontWeight: 700 }}>
            OI
          </td>
          <td>{cell(oi.sc)}</td>
          <td>{cell(oi.cc)}</td>
        </tr>
      </tbody>
    </table>
  );
}

export default function PrescriptionDetailModal({ prescription: rx, onClose, onEdit, onPrint }) {
  return (
    <div className="modal-overlay">
      <div className="modal-card modal-card--wide">
        <h2>Receta · {formatPatientName(rx.patients)}</h2>
        <p className="field-hint" style={{ marginTop: -6 }}>
          {formatDate(rx.date)}
          {rx.professional_id ? ` · ${formatProfessionalName(rx.professionals, { withRole: true })}` : ''}
        </p>

        <div className="form-row">
          <div>
            <h4 style={{ fontSize: 13, marginBottom: 6 }}>Lejos</h4>
            <LensSummaryTable block={rx.lejos} />
          </div>
          <div>
            <h4 style={{ fontSize: 13, marginBottom: 6 }}>AVsc / AVcc</h4>
            <AvSummaryTable av={rx.av} />
          </div>
        </div>

        <div className="form-row" style={{ marginTop: 14 }}>
          <div>
            <div className="field-hint">ADD</div>
            <div>{rx.add_esf != null ? `${rx.add_esf} ESF.` : '—'}</div>
          </div>
          <div>
            <div className="field-hint">ADD intermedia</div>
            <div>{rx.add_intermedia != null ? `${rx.add_intermedia} ESF.` : '—'}</div>
          </div>
        </div>
        <div className="form-row" style={{ marginTop: 8 }}>
          <div>
            <div className="field-hint">DP</div>
            <div>{rx.dp != null ? `${rx.dp} mm` : '—'}</div>
          </div>
          <div>
            <div className="field-hint">Uso</div>
            <div>{rx.uso || '—'}</div>
          </div>
        </div>

        <h4 style={{ fontSize: 13, margin: '16px 0 6px' }}>Cerca</h4>
        <LensSummaryTable block={rx.cerca} />

        <div style={{ marginTop: 10 }}>
          <div className="field-hint">Diagnóstico</div>
          <div>{rx.diagnostico?.length ? rx.diagnostico.join(', ') : '—'}</div>
        </div>

        {rx.reevaluar && (
          <p className="field-hint field-hint--error" style={{ marginTop: 10 }}>
            ⚠ Requiere reevaluar receta / corrección
          </p>
        )}

        {rx.notes && (
          <p style={{ marginTop: 14 }}>
            <strong>Observaciones:</strong> {rx.notes}
          </p>
        )}

        <div className="modal-actions">
          <button type="button" className="button-secondary" onClick={onClose}>
            Cerrar
          </button>
          {onPrint && (
            <button type="button" className="button-secondary" onClick={onPrint}>
              🖨 Imprimir receta
            </button>
          )}
          <button type="button" className="button-primary" onClick={onEdit}>
            Editar
          </button>
        </div>
      </div>
    </div>
  );
}
